import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@imaginelearning/web-api-core";
export class PermissionsService {
    constructor(http, environment) {
        this.http = http;
        this.environment = environment;
        this.baseUrl = this.environment.config.permissionsApiUrl;
    }
    // Method to get product permissions for a user from the permissions API
    getProductPermissions(userId, token) {
        return this.http
            .get(`${this.baseUrl}/user/${userId}/products`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .pipe(map((response) => {
            return response;
        }), catchError((error) => {
            console.error(`Error calling permissions api for userId ${userId}:`, error);
            const errorResponse = {};
            return of(errorResponse);
        }));
    }
    static { this.ɵfac = function PermissionsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PermissionsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Environment)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PermissionsService, factory: PermissionsService.ɵfac, providedIn: 'root' }); }
}
